import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { DeepPartial, useForm } from "react-hook-form";

import { CREATE_PROMPT_FRAGMENT } from "../prompt-fragment.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreatePromptFragmentInput } from "../../../__generated__/globalTypes";
import {
  CreatePromptFragmentMutation,
  CreatePromptFragmentMutationVariables,
} from "../../../__generated__/CreatePromptFragmentMutation";

interface IProps {
  defaultValues: DeepPartial<CreatePromptFragmentInput>;
  onCompleted: (id?: number | null) => any;
}

export const useCreatePromptFragment = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreatePromptFragmentInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreatePromptFragmentMutation,
    CreatePromptFragmentMutationVariables
  >(CREATE_PROMPT_FRAGMENT, {
    refetchQueries: ["PromptFragmentsQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createPromptFragment?.ok) {
        onCompleted(data.createPromptFragment.id);
      } else {
        throw Error(data?.createPromptFragment?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
